/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Detail_Meta_TitleInputs */

const id_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Perubahan | egdata.app`)
};

const ms_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiran Perubahan | egdata.app`)
};

const da_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringsdetalje | egdata.app`)
};

const de_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsdetails | egdata.app`)
};

const en_us2_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Detail | egdata.app`)
};

const es_es2_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalle del cambio | egdata.app`)
};

const es_mx2_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalle del cambio | egdata.app`)
};

const fil_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalye ng Pagbabago | egdata.app`)
};

const fr_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détail de la modification | egdata.app`)
};

const it_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettaglio modifica | egdata.app`)
};

const hu_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változás részletei | egdata.app`)
};

const nl_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingsdetail | egdata.app`)
};

const no_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringsdetalj | egdata.app`)
};

const pl_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szczegóły zmiany | egdata.app`)
};

const pt_br2_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar detalhes | egdata.app`)
};

const pt_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhe da alteração | egdata.app`)
};

const ro_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalii modificare | egdata.app`)
};

const fi_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutoksen tiedot | egdata.app`)
};

const sv_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringsdetalj | egdata.app`)
};

const vi_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiết thay đổi | egdata.app`)
};

const tr_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Detayı | egdata.app`)
};

const cs_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail změny | egdata.app`)
};

const bg_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детайл на промяна | egdata.app`)
};

const ru_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали изменения | egdata.app`)
};

const uk_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Деталі зміни | egdata.app`)
};

const ar_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفاصيل التغيير | egdata.app`)
};

const hi_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन विवरण | egdata.app`)
};

const th_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียดการเปลี่ยนแปลง | egdata.app`)
};

const ja_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更詳細 | egdata.app`)
};

const zh_cn2_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新详情 | egdata.app`)
};

const zh_hant1_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新詳情 | egdata.app`)
};

const ko_changelog_detail_meta_title = /** @type {(inputs: Changelog_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 상세 | egdata.app`)
};

/**
* | output |
* | --- |
* | "Change Detail \| egdata.app" |
*
* @param {Changelog_Detail_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const changelog_detail_meta_title = /** @type {((inputs?: Changelog_Detail_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Detail_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_changelog_detail_meta_title(inputs)
	if (locale === "ms") return ms_changelog_detail_meta_title(inputs)
	if (locale === "da") return da_changelog_detail_meta_title(inputs)
	if (locale === "de") return de_changelog_detail_meta_title(inputs)
	if (locale === "en-US") return en_us2_changelog_detail_meta_title(inputs)
	if (locale === "es-ES") return es_es2_changelog_detail_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_changelog_detail_meta_title(inputs)
	if (locale === "fil") return fil_changelog_detail_meta_title(inputs)
	if (locale === "fr") return fr_changelog_detail_meta_title(inputs)
	if (locale === "it") return it_changelog_detail_meta_title(inputs)
	if (locale === "hu") return hu_changelog_detail_meta_title(inputs)
	if (locale === "nl") return nl_changelog_detail_meta_title(inputs)
	if (locale === "no") return no_changelog_detail_meta_title(inputs)
	if (locale === "pl") return pl_changelog_detail_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_changelog_detail_meta_title(inputs)
	if (locale === "pt") return pt_changelog_detail_meta_title(inputs)
	if (locale === "ro") return ro_changelog_detail_meta_title(inputs)
	if (locale === "fi") return fi_changelog_detail_meta_title(inputs)
	if (locale === "sv") return sv_changelog_detail_meta_title(inputs)
	if (locale === "vi") return vi_changelog_detail_meta_title(inputs)
	if (locale === "tr") return tr_changelog_detail_meta_title(inputs)
	if (locale === "cs") return cs_changelog_detail_meta_title(inputs)
	if (locale === "bg") return bg_changelog_detail_meta_title(inputs)
	if (locale === "ru") return ru_changelog_detail_meta_title(inputs)
	if (locale === "uk") return uk_changelog_detail_meta_title(inputs)
	if (locale === "ar") return ar_changelog_detail_meta_title(inputs)
	if (locale === "hi") return hi_changelog_detail_meta_title(inputs)
	if (locale === "th") return th_changelog_detail_meta_title(inputs)
	if (locale === "ja") return ja_changelog_detail_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_changelog_detail_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_changelog_detail_meta_title(inputs)
	return ko_changelog_detail_meta_title(inputs)
});
export { changelog_detail_meta_title as "changelog.detail.meta.title" }